/* @flow */

import * as React from 'react';

import ReactTooltip from 'react-tooltip';

import {
    CheckIcon,
    ContactIcon,
    EmailIcon,
    ExternalLinkIcon,
    PhoneIcon,
    TimesIcon,
} from '../../../icon';

import './person-card-content.css';

type Props = {
    name: string,
    location: ?string,
    jobTitle: ?string,
    position: ?string,
    // added contact only
    email?: ?string,
    phone?: ?string,
    // addable person only
    hasEmail?: boolean,
    hasPhone?: boolean,
    isSelected?: boolean,
    onClickName?: () => any,
};

export function PersonCardContent(props: Props) {
    const isContact =
        typeof props.hasEmail === 'undefined' && typeof props.hasPhone === 'undefined';

    const getDetailStatusIcon = (hasDetail: ?boolean) =>
        hasDetail ? (
            <CheckIcon size={11} wrapWithDiv={false} />
        ) : (
            <TimesIcon size={12} wrapWithDiv={false} />
        );

    React.useEffect(() => {
        ReactTooltip.rebuild();

        return () => ReactTooltip.hide();
    });

    return (
        <div styleName='person-card-content'>
            {isContact ? (
                <ContactIcon size={15} wrapWithDiv={false} />
            ) : (
                <input type='checkbox' checked={props.isSelected} readOnly={true} />
            )}
            <div styleName='details'>
                {props.onClickName ? (
                    <div styleName='name-button-container'>
                        <div onClick={props.onClickName}>{props.name}</div>
                    </div>
                ) : (
                    <div>{props.name}</div>
                )}
                {isContact && props.email && <div>{props.email}</div>}
                {isContact && props.phone && <div>{props.phone}</div>}
                {props.jobTitle && <div>{props.jobTitle}</div>}
                {props.position && <div>{props.position}</div>}
                {props.location && <div>{props.location}</div>}
            </div>
            <div>
                {isContact ? (
                    <ExternalLinkIcon size={13} wrapWithDiv={false} />
                ) : (
                    <div styleName='has-phone-email'>
                        <div
                            styleName={!props.hasEmail && 'missing'}
                            data-tooltip-place='top-end'
                            data-tip={
                                props.hasEmail ? 'Add to view email address' : 'No email address'
                            }
                        >
                            {getDetailStatusIcon(props.hasEmail)}
                            <EmailIcon size={13} wrapWithDiv={false} />
                        </div>
                        <div
                            styleName={!props.hasPhone && 'missing'}
                            data-tooltip-place='top-end'
                            data-tip={
                                props.hasPhone ? 'Add to view phone number' : 'No phone number'
                            }
                        >
                            {getDetailStatusIcon(props.hasPhone)}
                            <PhoneIcon size={15} wrapWithDiv={false} />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
